interface NavigationStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export type NavigationStorageProvider = () => NavigationStorage;

const STORAGE_KEY = 'nimbalyst:web-console:navigation-expanded';

function browserStorage(): NavigationStorage {
  return window.localStorage;
}

export function readNavigationExpanded(
  getStorage: NavigationStorageProvider = browserStorage,
): boolean {
  try {
    return getStorage().getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function rememberNavigationExpanded(
  expanded: boolean,
  getStorage: NavigationStorageProvider = browserStorage,
): void {
  try {
    getStorage().setItem(STORAGE_KEY, String(expanded));
  } catch {
    // The in-memory preference still works when site data is unavailable.
  }
}
